import { type Interval } from "../../data/entities/offering.entity"
import { type OfferingType } from "./offering-type"

export enum OfferingProductInterval {
  Day = "day",
  Week = "week",
  Month = "month",
  Year = "year",
}

export class OfferingProduct {
  constructor(
    public readonly id: string,
    public readonly price: number,
    public readonly currencyCode: string,
    public readonly offeringType: OfferingType,
    public readonly name: string,
    public readonly billingInterval: Interval,
    public readonly trialPeriod: Interval,
    public readonly priceType: string
  ) {}
}

export class OfferingItem {
  constructor(
    public readonly type: OfferingType,
    public readonly products: OfferingProduct[]
  ) {}
}

export class Offering {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly type: string,
    public readonly offerings: OfferingItem[]
  ) {}
}
